import { CodeMappingActionTypes } from './types';
import { createAsyncAction } from '~lib/shared/redux/actions';
export const geoCodes = createAsyncAction(CodeMappingActionTypes.GEO_CODES);
export const abiCodes = createAsyncAction(CodeMappingActionTypes.ABI_CODES);
export const errorCodes = createAsyncAction(CodeMappingActionTypes.ERROR_CODES);
